import { Button, Checkbox, DataHeader, DataSource, HorizontalSpacer, Layout, Panel, Switch, Tab, Tabset, Textbox, Tree } from "@mcleod/components";

export abstract class AutogenLayoutResponsibilityControl extends Layout {
    buttonManageHierarchy: Button;
    checkboxAutoAssignCommissions: Checkbox;
    checkboxAutoAssignCustomerCommissions: Checkbox;
    checkboxBillingAgencyFilter: Checkbox;
    checkboxCallinScriptAgencyFilter: Checkbox;
    checkboxCarrierAgencyFilter: Checkbox;
    checkboxCustomerAgencyFilter: Checkbox;
    checkboxDataFusionAgencyFilter: Checkbox;
    checkboxDriversAgencyFilter: Checkbox;
    checkboxLocationAgencyFilter: Checkbox;
    checkboxOSDAgencyFilter: Checkbox;
    checkboxOrderMovementAgencyFilter: Checkbox;
    checkboxQuotesAgencyFilter: Checkbox;
    checkboxSettlementAgencyFilter: Checkbox;
    checkboxTractorsAgencyFilter: Checkbox;
    checkboxTrailersAgencyFilter: Checkbox;
    dataheaderTitle: DataHeader;
    horizontalspacerInPanel: HorizontalSpacer;
    panelTree: Panel;
    panelTreeHeader: Panel;
    sourceAgentAccessCtrl: DataSource;
    switchAutoAssignOrderMovement: Switch;
    switchAutoDispatchAutoAssignment: Switch;
    tabBilling: Tab;
    tabCallinScript: Tab;
    tabCarriers: Tab;
    tabCommissions: Tab;
    tabCustomers: Tab;
    tabDataFusion: Tab;
    tabDispatch: Tab;
    tabDrivers: Tab;
    tabGeneral: Tab;
    tabHierarchy: Tab;
    tabLocations: Tab;
    tabOSD: Tab;
    tabOrders: Tab;
    tabQuotes: Tab;
    tabSettlement: Tab;
    tabTractors: Tab;
    tabTrailers: Tab;
    tabsetGeneral: Tabset;
    tabsetMain: Tabset;
    textboxCarrierConfirmationMessage: Textbox;
    textboxCarrierContactEmails: Textbox;
    textboxCustomerConfirmationMessage: Textbox;
    textboxCustomerContactEmail: Textbox;
    textboxRespAssetDispatchResponsibility: Textbox;
    textboxRespBrokerageDispatchResponsibility: Textbox;
    textboxRespEdiAssign: Textbox;
    textboxRespOrderAssign1Quotes: Textbox;
    textboxRespOrderAssign: Textbox;
    treeMenu: Tree;
}
